import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import React from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
export var resolveColors = function resolveColors(color) {
  switch (color) {
    case 'red':
      {
        return ["var(--ds-background-accent-red-subtlest, #FFECEB)", "var(--ds-text-accent-red, #AE2E24)", "var(--ds-background-accent-red-subtler, #FFD5D2)"];
      }
    case 'yellow':
      {
        return ["var(--ds-background-accent-yellow-subtlest, #FFF7D6)", "var(--ds-text-accent-yellow, #7F5F01)", "var(--ds-background-accent-yellow-subtler, #F8E6A0)"];
      }
    case 'blue':
      {
        return ["var(--ds-background-accent-blue-subtlest, #E9F2FF)", "var(--ds-text-accent-blue, #0055CC)", "var(--ds-background-accent-blue-subtler, #CCE0FF)"];
      }
    case 'green':
      {
        return ["var(--ds-background-accent-green-subtlest, #DCFFF1)", "var(--ds-text-accent-green, #216E4E)", "var(--ds-background-accent-green-subtler, #BAF3DB)"];
      }
    case 'purple':
      {
        return ["var(--ds-background-accent-purple-subtlest, #F3F0FF)", "var(--ds-text-accent-purple, #5E4DB2)", "var(--ds-background-accent-purple-subtler, #DFD8FD)"];
      }
    case 'grey':
    default:
      return ["var(--ds-background-neutral, #091E420F)", "var(--ds-text, #172B4D)", "var(--ds-background-neutral-hovered, #091E4224)"];
  }
};
var baseStyles = css({
  borderRadius: "var(--ds-border-radius, 3px)",
  padding: "var(--ds-space-025, 2px)".concat(" ", "var(--ds-space-050, 4px)"),
  margin: '0 1px',
  position: 'relative',
  transition: 'background 0.3s',
  whiteSpace: 'nowrap'
});
export var DateLozenge = function DateLozenge(props) {
  var colors = resolveColors(props.color);
  if (colors === '') {
    colors = ['', '', ''];
  }
  var _colors = colors,
    _colors2 = _slicedToArray(_colors, 3),
    background = _colors2[0],
    color = _colors2[1],
    hoverBackground = _colors2[2];
  return (
    // eslint-disable-next-line @atlaskit/design-system/no-html-button
    jsx("span", {
      role: "button",
      css: [baseStyles,
      // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
      {
        cursor: props.onClick ? 'pointer' : 'unset',
        background: background,
        color: color,
        '&:hover': {
          background: hoverBackground
        }
      }]
    }, props.children)
  );
};